var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { css, html } from 'lit';
import { query } from 'lit/decorators.js';
import { PICAction, PIC, PICBase, customElement } from '../Internals';
let PICConfig = class PICConfig extends PICBase {
    constructor() {
        super(...arguments);
        this.isHidden_ = true;
        this.dataObj_ = {};
        this.usrCfg = PIC.getInstance.userConfig;
    }
    get isHidden() {
        if (this.modal) {
            return this.modal.isHidden;
        }
        return this.isHidden_;
    }
    set isHidden(isHidden) {
        this.isHidden_ = isHidden;
        if (this.modal) {
            this.modal.isHidden = isHidden;
        }
        this.requestUpdate();
    }
    static get styles() {
        const defaultStyle = css `
            .flex{
                display: flex;
            }
            .row{
                flex-direction: row;
            }
            .column{
                flex-direction: column;
            }
        `;
        return css `
          ${super.styles}
          ${defaultStyle}
        `;
    }
    connectedCallback() {
        super.connectedCallback();
        this.saveAction = new PICAction();
        this.toggleThemeAction = new PICAction();
        this.toggleThemeAction.type_ = 'internal';
        this.toggleThemeAction.eventFnc = this.toggleTheme.bind(this);
    }
    toggleTheme() {
        if (this.usrCfg)
            this.usrCfg.theme = this.usrCfg.theme === 'dark' ? 'light' : 'dark';
        this.requestUpdate();
    }
    handleSave() {
        // this.dataObj_['userLang'] = this.userLang.submitValue;
        // this.dataObj_['dateLang'] = this.datelang.submitValue;
        // //this.dataObj_['dateOptions'] = this.userLang.submitValue;
        // //this.dataObj_['timeOptions'] = this.userLang.submitValue;
        // this.dataObj_['currencyLang'] = this.currlang.submitValue;
        // this.dataObj_['currency'] = this.curr.submitValue;
        // this.dataObj_['numberLang'] = this.numlang.submitValue;
        // this.dataObj_['minMaxDigits'] = {min: Number(this.mindig.submitValue), max: Number(this.maxdig.submitValue)};
        if (this.usrCfg) {
            this.usrCfg.dateTimeFormat = this.userdatetimeformat.submitValue;
            this.usrCfg.dateFormat = this.userdateformat.submitValue;
            this.usrCfg.timeFormat = this.usertimeformat.submitValue;
        }
        this.dataObj_['datetimeFormat'] = this.userdatetimeformat.submitValue;
        this.dataObj_['dateFormat'] = this.userdateformat.submitValue;
        this.dataObj_['timeFormat'] = this.usertimeformat.submitValue;
        console.log(this.dataObj_);
        PIC.getInstance.msg('Magic save button pushed');
    }
    firstUpdated() {
        this.saveAction.type_ = 'internal';
        this.saveAction.eventFnc = this.handleSave.bind(this);
    }
    renderOldBody() {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
        return html `
        <div class="flex column">
                    <div class="flex row">
                        <div class="flex column">
                            <label class="pic-caption">Language</label>
                            <pic-text id="userlang" label='User Language' etype='default' density='high' value=${(_a = this.usrCfg) === null || _a === void 0 ? void 0 : _a.userLang}></pic-text>
                            <pic-text id="datelang" label='Date Language' etype='default' density='high' value=${(_b = this.usrCfg) === null || _b === void 0 ? void 0 : _b.dateLang}></pic-text>
                            <pic-text id="currlang" label='Currency Language' etype='default' density='high' value=${(_c = this.usrCfg) === null || _c === void 0 ? void 0 : _c.currencyLang}></pic-text>
                            <pic-text id="numlang" label='Number Language' etype='default' density='high' value=${(_d = this.usrCfg) === null || _d === void 0 ? void 0 : _d.numberLang}></pic-text>
                        </div>
                        <div class="flex column">
                            <label class="pic-caption">Hest</label>
                            <pic-text id="mindig" label='Min Digits' etype='default' density='high' value=${(_f = (_e = this.usrCfg) === null || _e === void 0 ? void 0 : _e.minMaxDigits) === null || _f === void 0 ? void 0 : _f.min}></pic-text>
                            <pic-text id="maxdig" label='Date Options' etype='default' density='high' value=${(_h = (_g = this.usrCfg) === null || _g === void 0 ? void 0 : _g.minMaxDigits) === null || _h === void 0 ? void 0 : _h.max}></pic-text>
                            <pic-text id="curr" label='Currency' etype='default' density='high' value=${(_j = this.usrCfg) === null || _j === void 0 ? void 0 : _j.currency}></pic-text>
                        </div>
                        <div class="flex column">
                            <label class="pic-caption">Date</label>
                            <pic-selector id="dateformat" label="Format"></pic-selector>
                            <pic-text id="datetimeopt" label='DateTime Options' etype='default' density='high' value=${((_k = this.usrCfg) === null || _k === void 0 ? void 0 : _k.dateTimeOptions) + ''}></pic-text>
                        </div>
                        <div class="flex column">
                            <label class="pic-caption">Time</label>
                            <pic-text id="timeopt" label='Time Options' etype='default' density='high' value=${((_l = this.usrCfg) === null || _l === void 0 ? void 0 : _l.timeOptions) + ''}></pic-text>
                        </div>
                    </div>
                </div>
            </div>
        `;
    }
    renderBody() {
        var _a, _b, _c, _d;
        return html `
            <pic-selector id="usertimeformat"  width='14rem' label='Time format' etype='default' density='high' value=${(_a = this.usrCfg) === null || _a === void 0 ? void 0 : _a.timeFormat}>
                <pic-optiongroup id="__DEFAUT__" minchars="0">
                    <data key="HH" val="HH"></data>
                    <data key="HHMM" val="HH:MM"></data>
                    <data key="HHMMSS" val="HH:MM:SS"></data>
                </pic-optiongroup>
            </pic-selector>
            <pic-text id="userdateformat"  width='14rem' label='Date format' etype='default' density='high' value=${(_b = this.usrCfg) === null || _b === void 0 ? void 0 : _b.dateFormat}></pic-text>
            <pic-text id="userdatetimeformat"  width='14rem' label='DT format' etype='default' density='high' value=${(_c = this.usrCfg) === null || _c === void 0 ? void 0 : _c.dateTimeFormat}></pic-text>
            <pic-checkbox
                id="usertheme"
                .isinput__=${false}
                .width=${'60px'}
                .density=${'high'}
                .eType=${'switch'}
                .label=${'Dark mode'}
                .value=${((_d = this.usrCfg) === null || _d === void 0 ? void 0 : _d.theme) === 'dark' ? 'true' : 'false'}
                .clickAction=${this.toggleThemeAction}
            >
            </pic-checkbox>
        `;
    }
    render() {
        return html `
        <pic-modal .isNew=${true} .isHidden=${this.isHidden} .title_=${'Settings'} .parent=${this}>
            <div slot="slot-modal-body">
                ${this.renderBody()}    
            </div>    
            <pic-button slot="slot-modal-footer" .action=${this.saveAction} label='Save' eType='contained' density='high'></pic-button>
        </pic-modal>
        `;
    }
};
__decorate([
    query('pic-modal')
], PICConfig.prototype, "modal", void 0);
__decorate([
    query('#userlang')
], PICConfig.prototype, "userLang", void 0);
__decorate([
    query('#datelang')
], PICConfig.prototype, "datelang", void 0);
__decorate([
    query('#currlang')
], PICConfig.prototype, "currlang", void 0);
__decorate([
    query('#numlang')
], PICConfig.prototype, "numlang", void 0);
__decorate([
    query('#mindig')
], PICConfig.prototype, "mindig", void 0);
__decorate([
    query('#maxdig')
], PICConfig.prototype, "maxdig", void 0);
__decorate([
    query('#timeopt')
], PICConfig.prototype, "timeopt", void 0);
__decorate([
    query('#datetimeopt')
], PICConfig.prototype, "datetimeopt", void 0);
__decorate([
    query('#curr')
], PICConfig.prototype, "curr", void 0);
__decorate([
    query('#userdatetimeformat')
], PICConfig.prototype, "userdatetimeformat", void 0);
__decorate([
    query('#userdateformat')
], PICConfig.prototype, "userdateformat", void 0);
__decorate([
    query('#usertimeformat')
], PICConfig.prototype, "usertimeformat", void 0);
PICConfig = __decorate([
    customElement('pic-config')
], PICConfig);
export { PICConfig };
//# sourceMappingURL=PICConfig.js.map